// Atividade-tab taxonomy (the SPA side of §13.3).
//
// Pure logic (no React) so it's unit-testable and so the component files
// export only components (keeps react-refresh happy — same split as
// `lib/range.ts`).
//
// The seven `Tipo` keys + three `Estado` values mirror the canonical Python
// source (`kwanza.dashboard.render.activity_types.ACTIVITY_TYPE_KEYS` + the
// route's `estado` enum). The backend parity test
// (`tests/test_dashboard_activity_i18n_parity.py`) asserts every key here has
// a matching i18n label. The SPA sends type *keys*, never an action list —
// constraint ② holds end-to-end.

import type { StringKey } from "./i18n";

export type ActivityType =
  | "faturas"
  | "comunicacao"
  | "aprovacoes"
  | "tarefas"
  | "correcoes"
  | "seguranca"
  | "aprendizagem";

/** Chip-display order — mirrors `ACTIVITY_TYPE_KEYS` (§13.3 table order). */
export const ACTIVITY_TYPES: ReadonlyArray<{
  key: ActivityType;
  labelKey: StringKey;
}> = [
  { key: "faturas", labelKey: "tipo.faturas" },
  { key: "comunicacao", labelKey: "tipo.comunicacao" },
  { key: "aprovacoes", labelKey: "tipo.aprovacoes" },
  { key: "tarefas", labelKey: "tipo.tarefas" },
  { key: "correcoes", labelKey: "tipo.correcoes" },
  { key: "seguranca", labelKey: "tipo.seguranca" },
  { key: "aprendizagem", labelKey: "tipo.aprendizagem" },
];

const LABEL_BY_KEY: Record<string, StringKey> = Object.fromEntries(
  ACTIVITY_TYPES.map(({ key, labelKey }) => [key, labelKey]),
);

/** Localized-label key for a row's `type`, or null for an unknown type. The
 * backend only emits the seven curated keys, so null is the defensive
 * fallback (the renderer drops a tag rather than leaking a raw verb). */
export function typeLabelKey(type: string): StringKey | null {
  return LABEL_BY_KEY[type] ?? null;
}

/** Tri-state Estado filter values, in display order (Tudo / Concluídas / A
 * precisar de atenção). */
export const ESTADO_VALUES = ["all", "done", "attention"] as const;
export type Estado = (typeof ESTADO_VALUES)[number];

export const ESTADO_LABEL_KEY: Record<Estado, StringKey> = {
  all: "estado.all",
  done: "estado.done",
  attention: "estado.attention",
};
